/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */
import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const messages = {
  contactInformation: () =>
    _t(translations.registrationPage.contactInformation, 'Contact information'),
  billingInformationTitle: () =>
    _t(
      translations.registrationPage.billingInformationTitle,
      'My billing information',
    ),
  billingInformation: () =>
    _t(translations.registrationPage.billingInformation, 'Billing information'),
  individualType: () =>
    _t(translations.registrationPage.individualType, 'An individual'),
  companyType: () => _t(translations.registrationPage.companyType, 'A company'),
  email: () => _t(translations.fields.email, 'Email address'),
  yourName: () => _t(translations.fields.yourName, 'Your name'),
  password: () => _t(translations.fields.password, 'Password'),
  passwordConfirm: () =>
    _t(translations.fields.passwordConfirm, 'Confirm Password'),
  forgetPassword: () =>
    _t(translations.registrationPage.forgetPassword, 'I forgot my password'),
  resetPassword: () =>
    _t(translations.registrationPage.resetPassword, 'Request password reset'),
  sendRequest: () =>
    _t(translations.registrationPage.sendRequest, 'Send request'),
  resetPasswordInstructions: () =>
    _t(
      translations.registrationPage.resetPasswordInstructions,
      'Instructions on how to reset your password have been sent to your email address',
    ),
  backLogin: () => _t(translations.registrationPage.backLogin, 'Back to login'),
  company: () => _t(translations.registrationPage.company, 'Company'),
  taxID: () => _t(translations.registrationPage.taxID, 'Tax ID'),
  vatNumber: () => _t(translations.registrationPage.vatNumber, 'Vat number'),
  name: () => _t(translations.registrationPage.name, 'Name'),
  address: () => _t(translations.registrationPage.address, 'Address'),
  country: () => _t(translations.registrationPage.country, 'Country'),
  state: () => _t(translations.registrationPage.state, 'State'),
  city: () => _t(translations.registrationPage.city, 'City'),
  choose: () => _t(translations.registrationPage.choose, 'Choose'),
};
